import React, { Component } from "react";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, Typography } from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import { IFuelGas } from "../../interfaces/IFuelGas";
import { RootState } from "../../reducers/rootReducer";
import { deleteFuelGas } from "../../slices/fuelGasSlice";
import { updateDeletedFuelGasId } from "../../slices/scenarioSimulatorSlice";
import { deleteFuelGasById } from "../../services/fuelgasServices";
import { updateDeletedFuelGasIdInPP } from "../../slices/productPredictorSlice";
import { AuthContextProps, withAuth } from "react-oidc-context";
import { getToken } from "../../utilities/helperFunctions";

interface IDeleteFuelGasProps {
    fuelGas: IFuelGas;
}

interface OIDCAuth {
    auth?: AuthContextProps
 }

const mapStateToProps = (state: RootState) => {
    return {
        fuelGases: state.fuelGas.fuelGases
    };
};

const mapDispatchToProps = dispatch => {
    return {
        deleteFuelGas: (fuelGas_id: string) => dispatch(deleteFuelGas(fuelGas_id)),
        updateDeletedFuelGasId: (fuelGas_id: string) => dispatch(updateDeletedFuelGasId(fuelGas_id)),
        updateDeletedFuelGasIdInPP: (fuelGas_id: string) => dispatch(updateDeletedFuelGasIdInPP(fuelGas_id)),
    };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type IDeleteFuelGasReduxProps = PropsFromRedux & IDeleteFuelGasProps & OIDCAuth;

type IDeleteFuelGasState = {
    showDialog: boolean;
    message: string;
    showLoading: boolean;
}
class DeleteFuelGas extends Component<IDeleteFuelGasReduxProps, IDeleteFuelGasState>{

    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            message: "",
            showLoading: false,
        }
    }

    toggleShowDialog = () => {
        this.setState({
            showDialog: !this.state.showDialog,
        })
    }

    deleteFuelGas = async () => {
        this.setState({
            showLoading: true,
        })
        const accessToken = await getToken(this.props.auth);
        let deleteFromDb = await deleteFuelGasById(this.props.fuelGas.id, accessToken);
        if (deleteFromDb.status) {
            await this.props.updateDeletedFuelGasId(this.props.fuelGas.id);
            await this.props.updateDeletedFuelGasIdInPP(this.props.fuelGas.id);
            await this.props.deleteFuelGas(this.props.fuelGas.id);
            this.setState({
                message: deleteFromDb.message,
            })
        }
        setTimeout(() => {
            this.toggleShowDialog()
            setTimeout(() => {
                this.setState({
                    message: "",
                    showLoading: false,
                })
            }, 200);
        }, 1000);
    }

    render() {
        return (
            <div className="control-header element">
                <button
                    className="button"
                    onClick={() => this.toggleShowDialog()}
                    disabled={!!this.props.fuelGas && this.props.fuelGas.id.startsWith("_DEFAULT")}
                >
                    Delete
                </button>
                <Dialog open={this.state.showDialog} onClose={() => this.toggleShowDialog()} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Delete Fuel Gas</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this Fuel Gas?
                        </DialogContentText>
                        {!!this.state.message && this.state.message !== "" && (
                            <Typography variant="body1" component="p" color="secondary">
                                {this.state.message}
                            </Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <button className="button" onClick={() => this.toggleShowDialog()} >
                            Cancel
                        </button>
                        <button className="button" onClick={() => this.deleteFuelGas()} disabled={this.state.showLoading}>
                            Delete {this.state.showLoading === true && (
                                <Fade
                                    in={this.state.showLoading}
                                    style={{
                                        transitionDelay: this.state.showLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <CircularProgress size={11} />
                                </Fade>
                            )}
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

};

export default withAuth(connector(DeleteFuelGas));